if (window.lazyImages === undefined) {
  window.lazyImages = true;

  const images = document.querySelectorAll('.lazy');

  const preloadImage = img => {
    const src = img.getAttribute('data-src');
    if (!src) {
      return;
    }
    img.src = src;
  };

  const imgOptions = {
    threshold: 0,
    rootMargin: '0px 0px 300px 0px',
  };

  const imgObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        preloadImage(entry.target);
        observer.unobserve(entry.target);

        images.forEach(image => {
          image.classList.remove('animate-pulse');
        });
      }
    });
  }, imgOptions);

  images.forEach(image => {
    imgObserver.observe(image);
  });
}
